import { useState } from "react";

export default function PaymentFailedPopup({ redirectTo = "/" }) {
  const handleAccess = () => {
    // Redirect to landing page or any page passed via props
    window.location.href = redirectTo;
  };

  return (
    <div className="w-full min-h-screen flex items-center justify-center bg-gradient-to-br from-[#ff6b6b50] via-[#ff4c4c50] to-[#ff3b3b50] p-4 relative overflow-hidden">
      
      {/* Floating Shapes */}
      <div className="absolute inset-0 -z-10 overflow-hidden">
        <div className="shape-1 absolute bg-[#ff4c4c] opacity-10 w-20 h-20 rounded-full top-[10%] left-[10%] animate-float"></div>
        <div className="shape-2 absolute bg-[#ff4c4c] opacity-10 w-32 h-32 rounded-full bottom-[10%] right-[10%] animate-float2"></div>
      </div>

      {/* Popup */}
      <div className="popup-overlay fixed inset-0 flex items-center justify-center z-50 animate-fadeIn">
        <div className="popup bg-white rounded-2xl p-8 shadow-2xl w-[90%] max-w-md relative animate-slideUp">
          
          {/* Failed Icon */}
          <div className="popup-icon w-[90px] h-[90px] bg-[#ff4c4c1a] border-2 border-[#ff4c4c33] text-[#ff4c4c] rounded-full flex items-center justify-center text-4xl mx-auto mb-6">
            <i className="fas fa-times-circle"></i>
          </div>

          {/* Title */}
          <h2 className="text-[#ff4c4c] text-2xl font-bold mb-3 text-center">
            Payment Failed!
          </h2>

          {/* Message */}
          <p className="text-gray-600 text-center mb-6 leading-relaxed">
            Unfortunately, your payment could not be processed. Please try again or contact support if the problem persists.
          </p>

          {/* Button */}
          <button
            onClick={handleAccess}
            className="popup-button bg-[#ff4c4c] hover:bg-[#e04343] text-white font-semibold py-3 px-10 rounded-full shadow-lg w-full flex items-center justify-center gap-2 animate-pulse"
          >
            <i className="fas fa-arrow-left"></i> Go to Home Page
          </button>
        </div>
      </div>
    </div>
  );
}
